<template>
    <div v-if="canShow('先天健康状态') && info && (info.xtjk || info.wylq)">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">先天健康状态</div>
        </div>
        <div class="sick-tongue">
            <div v-if="info.xtjk" class="inner-name">出生日期：{{ info.birthday }}</div>
            <div v-if="info.xtjk">{{ info.xtjk }}</div>
            <div class="table-mark">
            <table class="newre-table">
                <thead v-if="info.wylq">
                    <tr >
                        <th>五运六气</th>
                        <th>{{ info.created_at.split(' ')[0] }}，{{ info.wylq['YeaName'] }}</th>
                    </tr>  
                </thead>
                <tbody v-if="info.wylq && info.wylq['KfFeswPp']">
                    <tr>
                        <td>中运（岁运 大运）</td>
                        <td>{{ info.wylq['KfFeswPp'].year }}</td>
                    </tr>
                    <tr>
                        <td>主运</td>
                        <td>{{ info.wylq['KfFeswPp'].main }}</td>
                    </tr>
                    <tr>
                        <td>客运</td>
                        <td>{{ info.wylq['KfFeswPp'].custorm }}</td>
                    </tr>
                    <tr>
                        <td>司天</td>
                        <td>{{ info.wylq['KfFeswPp'].sitian }}</td>
                    </tr>
                    <tr>
                        <td>在泉</td>
                        <td>{{ info.wylq['KfFeswPp'].zaiquan }}</td>
                    </tr>
                    <tr>
                        <td>主气</td>
                        <td>{{ info.wylq['KfFeswPp'].main_air }}</td>
                    </tr>
                    <tr>
                        <td>客气</td>
                        <td>{{ info.wylq['KfFeswPp'].custorm_air }}</td>
                    </tr>
                </tbody>  
            </table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';

export default {
    name: 'ReportInnate',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info'])
    }
};
</script>
<style lang="scss" scoped>
@import './Innate.scss';
</style>
